import { Breadcrumb, Modal, message, Image, Row, Col, Button, Space, Radio, Card, Input, Select, Checkbox, Typography, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { InboxOutlined, HeartOutlined } from '@ant-design/icons';
import { useForm } from 'rc-field-form';
import axios from 'axios';
import './css/cramSchool.css';
const { Title, Paragraph, Text, Link } = Typography;

const InputOutline = styled.div`
    .ant-select-focused .ant-select-selector,
    .ant-select-selector:focus,
    .ant-select-selector:active,
    .ant-select-open .ant-select-selector {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
    }
    .ant-input{
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        border-radius:0px;
        background-color:#f5f5f5;
        border-width:2px
    }
    .ant-select-selector{
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        border-radius:0px;
        background-color:#f5f5f5;
    }
    .ant-input-status-error{
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        border-radius:0px;
        background-color:#f5f5f5;
        border-width:5px;
    }
`;
const Appointment = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const [grade_option, set_grade_option] = useState([]);
    const [learn_english_year, set_learn_english_year] = useState([]);
    const [agree, set_agree] = useState(false);
    const [additional_test, set_additional_test] = useState('');
    const [form_data, set_form_data] = useState([]);
    const [modal_contract, set_modal_contract] = useState(false)
    const [data, setData] = useState([{
        key: 1,
        name: 'client',
        placeholder: '名字（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 2,
        name: 'phone',
        placeholder: '電話（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 3,
        name: 'school',
        placeholder: '就讀學校（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 4,
        name: 'grade_id',
        placeholder: '現今同學的年級',
        type: 'select',
        value: '',
    }, {
        key: 7,
        name: 'school_score',
        placeholder: '在校成績（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 8,
        name: 'learn_english_year_id',
        placeholder: '學習英文多久',
        type: 'select',
        value: '',
    }, {
        key: 5,
        name: 'e_mail',
        placeholder: '電子郵件（選填）',
        type: 'input',
        value: '',
        required: 'false',
    }, {
        key: 6,
        name: 'question',
        placeholder: '想瞭解的事情（選填）',
        type: 'input',
        value: '',
        required: 'false',
    }])
    useEffect(() => {
        get_grade();
        get_learn_english();
    }, [])
    const get_grade = () => {
        axios
            .get('/cramSchool/api/grade')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                set_grade_option(data_tmp)
            })
    }
    const get_learn_english = () => {
        axios
            .get('/cramSchool/api/learn_english_year')
            .then((response) => {
                let data_tmp = [];
                response.data && response.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['learn_english_year_id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                set_learn_english_year(data_tmp);
            })
    }
    const onSubmit = () => {
        if (form_data['client'] != '' && form_data['phone'] != '' && form_data['grade_id'] && form_data['school']) {
            axios
                .post('/cramSchool/api/contact', [form_data])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        messageApi.open({
                            type: 'error',
                            content: '送出失敗',
                        });
                    } else {
                        messageApi.open({
                            type: 'success',
                            content: '已成功送出，會盡快聯繫',
                        });
                        // set_form_data(pre => {
                        //     return (
                        //         {
                        //             client: '',
                        //             phone: '',
                        //             school: '',
                        //             grade_id: '',
                        //             e_mail: '',
                        //             question: ''
                        //         }
                        //     )
                        // })
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000)
                    }
                })
        } else {
            messageApi.open({
                type: 'error',
                content: '請檢查名字、電話、就讀學校、年級是否填寫',
            });
        }
    };
    const handleChange = (name, value) => {
        set_form_data(pre => {
            return ({
                ...pre,
                [`${name}`]: value
            })
        })
    }
    useEffect(() => {
        console.log(form_data);
    }, [form_data])
    return (
        <>
            {contextHolder}
            <InputOutline>
                <Modal
                    open={modal_contract}
                    // onOk={hideModal}
                    onCancel={e => set_modal_contract(false)}
                    footer={false}
                >
                    <div style={{ padding: '10px', maxHeight: '450px', overflowY: 'scroll' }}>
                        <h1>隱私權條款範本文件</h1>
                        <span>非常歡迎您光臨「私立MERCY文理短期補習班」（以下簡稱本網站），為了讓您能夠安心的使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，請您詳閱下列內容：</span>
                        <h4>一、隱私權保護政策的適用範圍</h4>
                        隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。
                        <h4>二、個人資料的蒐集、處理及利用方式</h4>
                        <p>•	當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，本網站不會將個人資料用於其他用途。</p>
                        <p>•	本網站在您使用服務信箱、問卷調查等互動性功能時，會保留您所提供的姓名、電子郵件地址、聯絡方式及使用時間等。</p>
                        <p>•	於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。</p>
                        <p>•	為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。</p>
                        <h4>三、資料之保護</h4>
                        <p>•	本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。</p>
                        <p>•	如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。</p>
                        <h4>四、網站對外的相關連結</h4>
                        <p>本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。</p>
                        <h4>五、與第三人共用個人資料之政策</h4>
                        <p>本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。</p>
                        <p>前項但書之情形包括不限於：</p>
                        <p>•	經由您書面同意。</p>
                        <p>•	法律明文規定。</p>
                        <p>•	為免除您生命、身體、自由或財產上之危險。</p>
                        <p>•	與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集著依其揭露方式無從識別特定之當事人。</p>
                        <p>•	當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</p>
                        <p>•	有利於您的權益。</p>
                        <p>•	本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。</p>
                        <h4>六、Cookie之使用</h4>
                        為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的 Cookie，若您不願接受 Cookie 的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕 Cookie 的寫入，但可能會導致網站某些功能無法正常執行。
                        <h4>七、隱私權保護政策之修正</h4>
                        本網站隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於網站上。
                    </div>
                </Modal>
                <Col span={24} style={{ backgroundColor: '#f5f5f5', padding: '10px' }}>
                    <Row justify='center' style={{ paddingBottom: '10px' }}>
                        <div style={{ fontSize: '70px' }}>Contact US</div>
                    </Row>
                    <Row gutter={[0, 8]} justify='center'>
                        <Col sm={{ span: 24 }} md={{ span: 10 }} style={{ position: 'relative' }}>
                            <Col style={{ position: 'absolute', top: '-10%', zIndex: 1 }}>
                                <svg width="50%" preserveAspectRatio="xMidYMid meet" data-bbox="10 44.8 180 110.4" viewBox="10 44.8 180 110.4" height="100" width="100" xmlns="http://www.w3.org/2000/svg" data-type="shape" role="presentation" aria-hidden="true">
                                    <g >
                                        <path fill='#FF73D0' d="M190 74.6s-.8-1.9-1.1-2.8c.2.2 0-.1-.1-.4v.2c-.1-.2-.2-.8-.3-1v.2-.1.4-.1c0 .1-.1 0-.2 0l-.1-.4.2-.2-1.3-4.1-3.4-3.2-8.6 1.2-6.9-1-16.7 1.4-1.1 1c-3.4-1.5-7.5.7-11.1-.2v.8c-1 .1-1-.4-1.2-.5-2.1.2-4.3.4-6.4.7-.4-.2-.9-.5-1.2-.7v-.3c.1 0 .1-.1 0-.1v-.3l-.3-1.6c.1-.1.2-.1.3.2.5 0 1.2.3 1.7 1l-.1-.8c.1 0 .5 1.1.4.1l.2-.4c.2 0 .2-.4.4 0 0 0 0 .1.1.1v-.1c.4.3-.1-.7.3-.3.1.3.1-.1.1-.4h.3l.2.6c.4.4.4-.1.6-.5h.4c.3.4.5 1.2.5 1.9 0-1 0-.7.2-1.2.1.4.1.5.1.9.3.4.1-.4.3-.4 0-.4-.1-.8-.1-1.3.4 0 .8-.1 1.3-.1.1 0 .2 0 .4-.1h.2c.6-.1 1.3-.2 1.9-.3 0 .1.1.2.1.2l-.1-.2c.1 0 .2 0 .4-.1.1.4.1.9.1 1.2l.1-.7.1.8c0-1 .2.1.3-.4.1.3 0 .5.1.6l.2-1.2-.2.5-.1-.9c.2 0 .5-.1.7-.1.1.1.1.3.3.4 0-.1-.1-.3-.1-.5h.1c0 .1.1.3.1.3V62c.1 0 .3-.1.4-.1v.1-.1h.1v.6-.6c.1 0 .2 0 .3-.1v.2l.9.1.1.7c0-1 .5.3.3-.9.2.6.6-.5.6.8.5 0 .7-1.3 1.4-.7.3 1.1.9.7 1.4.8.8-.5 1.3-1 2.1-1.4.6 1.6 1.2-.6 1.8.3l.1-.7c.4 1 .9-.3 1.5.7.1-.3.2-.4.2-.4s-.1-.2-.1-.6c.2.3.4-.1.4.7v.1c0 .8.4-.4.6.3l-.1-.9.3.1-.1.2c.6-1 1-.8 1.4-.5.4.2.8.5 1.4-.4-.2 1 .2-.5.2.5.3 1.3.5-.3.8-.6V60l.4.1c-.3 1.3.3-1.1.1 0 .5.5 1.1.5 1.7.5.6 0 1.3-.1 1.8.1v-.3c.3.1.7-.3.9.3.2.6.6-.8.7-.8.3-.5.4.4.3.5.3-.2.7-1.3 1-.7 0 1.1 1.2-.9 1 .3v-.1c.2.5.4.4.7.2.3-.1.5-.3.7.2 0 0 0 .1-.1.2 0 0 .4-.9.9-1.8s1-1.7 1-1.7.2-1 .3-2.1c.2-1 .3-2.1.3-2.1l-.2-1.8-.2-1.8h-.5c-.3 0-.7 0-1 .1l-.1-.6-1-3.4-1.2.4-1.2.4-2.1-1.3s-.3 0-.8.1-1.1.2-1.7.2c-.6.1-1.2.2-1.7.2-.5.1-.8.1-.8.1l-.3 1c-1.1-1.6-2.2.4-3.3-.7v.8c-.3.1-.3-.4-.4-.6-1.1.2-2.1.5-3.1.7-.3.1-.6.2-1 .2-.6-.3-1.1-.6-1.1-.1v-.2.5c-.9.1-1.8.1-2.7-.2-.3-.5-1-.1-1.2-.7-.6.9-1.3 1.1-2 1.2l-.2-.2.1.1h-.2.1v-.1c-.1-.1-.4-.1-.8-.1v.4c-.3.2-.7 0-1-.2.4-.1.7-.2 1-.2v-.3c-.4.1-.9.4-1.2.4-.2-.1-.6-.8-.4-1.2l-.2.7c-1.5.2-1.5.3-3.2-.3l.2.3c-.3.2-.6.5-.7-.1-1 0-2-.3-2.7-1v.8c-.2 0-.7-1.1-.6-.1l-.4.4c-.3 0-.4.4-.8 0 0 0 0-.1-.1-.1v.1c-.7-.3.1.7-.7.3-.3-.5-.1 1-.5.9l-.5-1c-.7-.5-.7.6-1.5.7-.5-.3-.8-1.2-.7-2.1-.2 1.1-.1.7-.5 1.2-.1-.4-.1-.5 0-.9-.5-.4-.2.4-.6.4 0 .8.1 2.1 0 2.1l.2.2c-.3-.1-.7 0-1.2.1v-.1l-.1.1c-.1 0-.2.1-.3.1l-.1-.4-.6.3.1.1c-.1.1-.6.3-.9.1v-.3c-.9-.7-1.4.5-2.3.7v-.6c-.4-.5.1.9-.4.7l-.1-.7c-.2 1-.5-.1-.8-.4l.3.9-.5-.1c-.5-.2-.5-1.1-.5-1.6l-.2.8-.2-.8c-.1 1-.3-.1-.6.5-.1-.3 0-.5-.2-.6l-.5 1.3.3-.6.2 1.2c-.3 1-.6 0-.9.4l.2-.4c-.5.4-.6-.1-.9-.3.1.2.3.5.1.7-.1.1-.2-.4-.3-.5.1.8-.2 1.3-.6 1v-.3c-.1.1-.1.4-.2.2l-.1-.9-.1.9c-.2-.2-.4.5-.5-.1l.1-.2h-1.5l-.1-.7c0 1-.8-.2-.6 1-.4-.6-1 .6-1.1-.7-.9.1-1.2 1.5-2.5 1-.6-1.1-1.7-.5-2.4-.5-1.3.7-2.2 1.4-3.5 2-1.2-1.4-2.1 1-3.2.3l.3 1c-.8-.9-1.5.5-2.6-.3-.1.3-.2.4-.2.5 0 0 .1.1.2.5-.3-.2-.7.2-.9-.6V53c-.1-.8-.7.5-1.1-.1l.3.8H95l.1-.2c-.2.3-.4.5-.6.7-.1 0-.1.1-.2.2-.1-.3 0-.5-.2-.6l-.6.8c-1 .1-2-.5-3 .9 0-1-.3.6-.5-.4-.8-1.2-.8.5-1.2.9v.2h-.7c.1-.9-.1-.1-.1.2v-.2c-.5-.2-1-.2-1.6-.2l-.1-.3c0 .2-.1.3-.1.3-.2 0-.3.1-.5.1s-.3 0-.4.1c-.5.1-1 .3-1.4.4-.1-.1-.2-.3-.1-.6-1.5.1-2.1 1.6-4 1.2-.8-1-2.5-.4-3.7-.3-2.2.9-3.5 1.5-5.8 2.3-1.7-1.4-3.4 1.2-5 .5l-.3.9c-1.2-.8-2.5.7-4-.1l-.5.5c.1 0 .2.1.3.5-.4-.2-1.2.3-1.3-.5l.1-.1c-.1-.8-1.1.6-1.7 0l.4.8h-.8l.2-.2c-2.9 2.5-4.9 0-7.6 2.3.2-1-.5.6-.7-.4-1-1.1-1.4.5-1.9 1v.2l-1.1.1c.4-1.4-.6 1.2-.2 0-.3 0-.5-.1-.8-.1-.1-.2-.2-.4-.4-.6v.6h-.1c-.1-.3-.2-.7-.2 0-.7 0-1.5.1-2.2.3-.1-.4-.2-.9-.2-1.4 0 1 0 .7-.2 1.2-.1-.4-.1-.5-.1-.9-.3-.5-.1.4-.2.4 0 .2.1.5.1.8-1 .2-2 .5-3 .7-.1 0-.2 0-.3.1-.1-.3-.1-.7-.1-1v.7l-.2-.8c.1 1-.1-.1-.2.4-.1-.3-.1-.5-.2-.6l-.1 1.2.1-.5.1.7c-.2 0-.4.1-.7.1 0 0 0-.1-.1-.1v.1c-.2 0-.3 0-.5.1V66v.1c-.2 0-.5 0-.7.1l.2.3h-.3l-.2-.7c.1.9-.4-.2-.1.9-.3-.5-.3.6-.6-.7-.4 0-.4 1.3-1 .8-.5-1.1-.9-.6-1.2-.6-.5.6-.8 1.2-1.3 1.7-.8-1.5-.8.8-1.4 0l.1.7c-.5-.9-.6.4-1.3-.5 0 .3 0 .4-.1.4 0 0 .1.1.2.5-.2-.2-.3.2-.5-.6v-.1c-.2-.8-.2.5-.5-.2l.3.8-.2-.1v-.2c0 .1 0 .2-.1.3-.3.1-.5.3-.8.5-.3-.1-.7-.3-.8.4h-.1c0-.1 0-.1 0 0-.1 0-.2-.1-.2-.3v.1c-.3-.6-.4-.4-.4-.1-1.3-.2-2.2 1.2-3.7.7V70l-1.2 2.4c-.1 0-.2.3-.3.5l-.2.1c-.1.1-.2.1-.3-.3v.1c-.6-.8-.5.8-1.1.1v-.2l.3 3.9 1.4 4 .6 1.2.2.6-.3-.1v-.2c-.6 2.1-1.7-.5-2.2 1.5-.1-1-.1.5-.3-.5-.5-1.2-.4.4-.5.8v.2h-.4c-.1-1.3 0 1.1-.1 0-1.1-.8-2.1.5-3.2.3l.1.3c-.3 0-.5.5-.8 0-.3-.5-.3.9-.3 1-.1.6-.5-.3-.5-.4-.2.3-.2 1.4-.6 1-.4-1.1-.7 1.3-.9 0v.1c-.6-.8-.7.8-1.3.1v-.2l-.1 3.9 1.2 4.1 1.5 3.2 2-1.2.8.4c-.1.3-.3.7-.5 1l-1 2.4 1.2 1.8c.6.9 1.1 1.8 1.1 1.8s.9.6 1.9 1.2c.9.6 1.9 1.2 1.9 1.2s.4-.2 1.1-.5c.7-.3 1.6-.6 2.5-1 1.8-.7 3.6-1.3 3.6-1.3h6.4s.2 0 .6-.1l.3 1.2c-.7.3-1.4.7-1.6 1.1 0 0 1 .4 2.1.9l.1.3.4 1-.1 1.5.1 1.4c-1.2 0-2.1 1.3-3.5 1v-.2l-2 4.5 1.7 3.5c-.6-.1-1.3-.2-2.2-.5v-.1c-.2.1-.1.2-.5.1l1 .4c-.5.4-.8.9-1.5 1.1-.2-.1-.3-.3-.3-.4l-1.6.5-.6-.5c-.4.4.1 1.7-1.4 1.3.7.8-.6.7-.3 1.1-.1-.1-.3-.2-.4-.4-.8.3-2.2.9-2.5 1.4 0 0 .5.2 1.2.5l-1 3.6.4 4.2 1 3.4.6-.2.8 2.2.3.3c-.6-.1-.8.7-1.5.5l.2.3c-.2 0-.2.5-.5 0-.3-.4.1.9.1 1 .1.5-.4-.2-.4-.4 0 .2.3 1.3-.1.9-.5-1 0 1.2-.5.1v.1c-.6-.7-.2.8-.7.2 0 0 0-.1-.1-.2l1.2 3.7 2 3.7 1.9 2.9s.2-.3.3-.6c.2-.3.3-.6.3-.6l1.4.9s.4-.3.9-.6c.4-.3.9-.6.9-.6v-.2l1 1.7 1.4 1 .4.9 1.6 3.1.9-1.1 1.4.9 2.1-1.2-.2-1c1 1.4.9-.6 1.8.4l-.3-.8c.1-.1.3.4.4.5 1.2-.6 2.1-2.1 3.6-1.5.3.5.5.1.8.6 0-1.1.4-1.2.8-1.2v.1l.1-.2c0 .1.1.2.1.2 0-.8.5-.2.8 0v.1c1.4-.3 2.2-2.2 4-1.7 1.1 1 1.2-1 2.3-.2.4.7 1.7-.4 1.7-.8l-.5-.9c.4-.6.9.1 1.1-.5h.1c.2-.1.4-.1.6-.2.1.2.3.4.5.6v.1s0-.2.1 0l-.3-.5v-.3c.1 0 .1 0 .2-.1.1.3.1.2 0 0 .1 0 .2-.1.3-.1l.2.4c0-.1-.1-.2-.1-.4h.1c1.2-.4 2-.6 2-.6l.7-1.2c3 .9 5.7-1.7 8.8-1.3l-.1-.8c.8-.2.8.3 1.1.4 7.1-2 14.3-4.8 21.1-5.3.8.4 2.6-.4 3.2.1 1.9-1.5 4.1-2 6.3-2.4l-.1.1 1-.4c.1.1.1.1.1.2 1-1 2.9-.7 4.4-.7l-.1.1c8.1-1.7 15.3-4.9 23.5-5.6 4 .4 7.9-2.3 12.5-2.2.4.2 1.9 0 3.6-.4l.6 1.5.8-1 1.2 1.1 1.8-1-.1-1c.8 1.5.8-.5 1.5.6l-.2-.8c.1-.1.2.4.3.5 1-.5 1.9-1.8 3.1-1.1.2.5.4.1.7.6.1-1.1.4-1.1.7-1.1v.1l.1-.2c0 .1.1.2.1.2 0-.7.4-.1.7.1v.1c1.2-.2 2-2 3.5-1.2.9 1.1 1.1-.8 2 .1.3.8 1.5-.2 1.5-.6l-.4-.9c.4-.6.8.3 1-.6v.2c.1.2-.4-2 .9.5v.1s0-.2.1 0l-.3-.6c0-.3-.1-.7 0-.8 0 .1.1.3.2.4l.2-.2.2.6c0-.4-.4-1.7 0-1-.3-.9-.1-.6-.2-1 0 .1.1.3.2.4.1-.1.2-.4.1-.9l.6.5c.2-.3.1-.8.3-1.2.1.2.1.1.2-.1.2-.1.4-.1.8 0-.4-.4-.2-.6 0-.7.2.1.4.1.6 0l-.4.2c.2 0 .4.2.5.2.3 0 .1-.2-.1-.4.4-.1.8-.3 1.2-.1l-.1-.3c.2 0 .4-.4.6.1.2.4.2-.3.2-.7.1-.1.2-.2.2-.3.1.2.1.4.1.5.1-.2.2-1.4.5-.9.2 1.1.5-1.2.7.1v-.1c.4.9.5-.7.9.1v.2l.3-3.9-.5-4.2-.7-2.4c.3-.1.6 0 .6.3v-.1c.8.4 1.4.2 2.1-.1.7-.2 1.4-.5 2.2-.1 0 0 0 .1-.1.2l.4-.6c.3-.4.6-.9 1-1.4.4-.6.9-1.1 1.2-1.5.1.1.2.3.3.5v.1s0-.2.1 0l-.2-.4v-.3l.2-.2s0-.1-.1-.3c.1.1.1.3.1.4l.3-.2.3.6c0-.4-.4-1.7.1-1-.3-.9 0-.6-.2-1 0 .1.1.3.2.4.1-.1.3-.5.3-1 0 0-.4-.6-.7-1.2.1-.1.3-.3.4.1v.2s.2-.9.4-1.9c.2-.9.5-1.9.5-1.9l.2-3.6c1.1 0 2.1-.9 3.4-.4 0 0 0 .1-.1.2l2.8-4.1-1.2-4.1-.2-.2.2-.7-.7-4.2-.2-.4c.2 0 .3.1.5.3.2.8 1.7 0 1.7-.4l-.3-1c.5-.5.9.4 1.2-.4v.2c.1.2-.2-2 1 .6v.1s0-.2.1 0l-.2-.6c0-.3 0-.7.1-.8 0 .1.1.3.1.5l.2-.2.2.6c0-.4-.2-1.7.1-1-.2-.9 0-.6-.1-1 0 .1.1.3.1.4.1-.1.3-.4.3-.9zM25.2 137.7zm68.5-83.2c.1 0 0 0 0 0zm76.2 62.1zm18.4-45.8c.1 0 .1 0 0 0z"></path>
                                    </g>
                                </svg>
                            </Col>
                            <Col span={24} style={{ zIndex: 20 }}>
                                <Row gutter={[8, 8]}>
                                    <Col span={24} style={{ fontSize: '30px' }}>暸解更多</Col>
                                    <Col span={24} style={{ fontSize: '17px' }}>歡迎有興趣的同學/家長，留下您的聯絡資訊</Col>
                                    <Col span={24} style={{ fontSize: '17px' }}>我們會盡快聯繫您</Col>
                                </Row>
                            </Col>
                        </Col>
                        <Col sm={{ span: 24 }} md={{ span: 10 }}  >
                            <Form autoComplete="off">
                                <Row gutter={[8, 24]}>
                                    {grade_option && data.map((value, key) => {
                                        if (value.type == 'select') {
                                            if (value.key == 4) {
                                                return (
                                                    <Col sm={{ span: 24 }} md={{ span: 12 }}  >
                                                        <Select
                                                            style={{
                                                                width: "100%",
                                                            }}
                                                            labelInValue
                                                            placeholder={value.placeholder}
                                                            value={form_data['grade_name'] || value.placeholder}
                                                            onChange={(value) => set_form_data(pre => {
                                                                return ({
                                                                    ...pre,
                                                                    'grade_id': value.value,
                                                                    'grade_name': value.label,
                                                                })
                                                            })}
                                                            options={grade_option}
                                                        />
                                                    </Col>
                                                )
                                            } else {
                                                return (
                                                    <Col sm={{ span: 24 }} md={{ span: 12 }}  >
                                                        <Select
                                                            style={{
                                                                width: "100%",
                                                            }}
                                                            labelInValue
                                                            placeholder={value.placeholder}
                                                            value={form_data['learn_english_year_id'] || value.placeholder}
                                                            onChange={(value) => set_form_data(pre => {
                                                                return ({
                                                                    ...pre,
                                                                    'learn_english_year_id': value.value,
                                                                    'learn_english_year_name': value.label,
                                                                })
                                                            })}
                                                            options={learn_english_year}
                                                        />
                                                    </Col>
                                                )
                                            }

                                        } else {
                                            return (
                                                <Col sm={{ span: 24 }} md={{ span: 12 }}  >
                                                    <Form.Item
                                                        // {...formItemLayout}
                                                        name={value.name}
                                                        label=""
                                                    // rules={[
                                                    //     {
                                                    //         required: `${value.required}`,
                                                    //         message: '',
                                                    //     },
                                                    // ]}
                                                    >
                                                        <Input placeholder={value.placeholder}
                                                            onChange={(e) => handleChange(value.name, e.target.value)}
                                                            value={form_data[`${value.name}`] || value.placeholder}
                                                        />
                                                    </Form.Item>

                                                </Col>
                                            )
                                        }
                                    })}
                                    <Col span={24}>
                                        <Row gutter={[0, 16]}>
                                            <Col span={24} style={{ color: '#006D9B', fontSize: '17px' }}>有無考取檢定*</Col>
                                            <Col sm={{ span: 24 }} md={{ span: 20 }}>
                                                <Col span={24}>
                                                    <Radio.Group onChange={(e) => set_additional_test(e.target.value)} value={additional_test}>
                                                        <Space direction="vertical">
                                                            <Row>
                                                                {/* <Col sm={{ span: 24 }} md={{ span: 12 }}> */}
                                                                <Radio value={1} style={{ color: '#006D9B', fontSize: '15px' }}>有</Radio>
                                                                {/* </Col> */}
                                                                {additional_test == '1' && (
                                                                    <Col sm={{ span: 24 }} md={{ span: 18 }} >
                                                                        <Input
                                                                            value={form_data['test_name'] || ''}
                                                                            placeholder={'請輸入檢定名稱'}
                                                                            onChange={(e) => additional_test == '1' ?
                                                                                set_form_data(pre => {
                                                                                    return ({
                                                                                        ...pre,
                                                                                        'test_name': e.target.value
                                                                                    })
                                                                                }) : null} />
                                                                    </Col>)}
                                                            </Row>
                                                            {/* <Col sm={{ span: 12 }} md={{ span: 12 }}> */}
                                                            <Radio value={0} style={{ color: '#006D9B', fontSize: '15px' }}>沒有</Radio>
                                                            {/* </Col> */}
                                                        </Space>
                                                    </Radio.Group>

                                                </Col>
                                            </Col>
                                            <Col span={24}>
                                                <Checkbox checked={agree} onChange={e => set_agree(!agree)} style={{ color: '#006D9B', fontSize: '15px' }}>
                                                    <span onClick={e => set_modal_contract(true)} style={{ textDecoration: 'underline' }}>我同意這些條款和條件</span>
                                                </Checkbox>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Row justify="center" style={{ padding: '10px' }}>
                                            <Button className='example' block style={{ background: agree == true ? '#566FB8' : 'gray' }} size='large' onClick={onSubmit} disabled={agree == true ? false : true}>
                                                <div style={{ color: '#ffffff', fontSize: '14px' }}>
                                                    送出
                                                </div>
                                            </Button>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row >
                </Col>
            </InputOutline >
        </>
    )
}
export default Appointment;